import styled from 'styled-components';
import {Select, Space} from 'antd';
import DebouncedInput from '../../../DebouncedInput';
import Tabs from '../../../Tabs';

const StyledJournalEntriesTabsContainer = styled.div`
  display: flex;
  min-height: calc(100vh - 66px);
  overflow-x: hidden;
  padding: 24px;
  position: relative;
  transition: .3s ease-in-out;

  .accounting-details-panel {
    margin-right: 24px;
    & > div {
      position: fixed;
      top: 90px;
    }
  }

  .accounting-details-content {
    &:has(> div:nth-child(3)) > div:nth-child(2) {
      max-height: calc(100vh - (66px + 24px * 2 + 56px) - 73px);
    }
  }
`;

const StyledJournalEntriesTabs = styled(Tabs)`
  .ant-tabs-content-holder {
    padding: 24px 0;
  }
`;

const StyledCheckedCircleIconContainer = styled.div`
  align-items: center;
  background-color: ${props => props.theme.colors.neutral_2};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  height: 30px;
  width: 30px;

  svg {
    path {
      fill: ${props => props.theme.colors.neutral_7};
    }
  }
`;

const StyledJournalEntriesTabsIconSpace = styled(Space)`
  display: flex;

  &:not(.justify-start) {
    justify-content: center;
  }

  & > .ant-space-item {
    display: flex;
  }

  svg {
    height: 24px;
    width: 24px;
    path {
      fill: ${props => props.theme.colors.neutral_7};
    }
  }
`;

const StyledJournalEntriesTabsInput = styled(DebouncedInput)`
  min-width: 100px;
  width: max-content;
  padding-left: 0;
`;

const StyledJournalEntriesTabsSelect = styled(Select)`
  flex: 1;
  min-width: 100px;

  &.ant-select-single:not(.ant-select-customize-input) {
    .ant-select-selector {
      padding-left: 0;

      .ant-select-selection-search {
        inset-inline-start: 0;
      }
    }
  }
`;

const StyledJournalEntryTabContainer = styled(Space)`
  padding: 0 24px;
  position: relative;
  width: 100%;

  .ant-table-cell-actions {
    opacity: 0;
    transition: opacity 0.2s;

    & > {
      pointer-events: none;
    }
  }

  .ant-table-cell-row-hover {
    .ant-table-cell-actions {
      opacity: 1;

      & > {
        pointer-events: auto;
      }
    }
  }

  .journal-entry-review-tab-filters {
    & > div {
      overflow: hidden;
    }
  }
`;

const StyledJournalEntrySyncSpace = styled(Space)`
  & > .ant-space-item {
    align-items: center;
    display: flex;
  }
`;

export {
  StyledJournalEntriesTabs,
  StyledJournalEntriesTabsContainer,
  StyledJournalEntriesTabsInput,
  StyledJournalEntriesTabsSelect,
  StyledJournalEntriesTabsIconSpace,
  StyledCheckedCircleIconContainer,
  StyledJournalEntryTabContainer,
  StyledJournalEntrySyncSpace,
}
